import Joi from 'joi';
import api from '../../api';
import { contentTypeSchema } from '../schemas';

/**
 * Get a content type by its ID.
 * @param {string} contentTypeId
 * @returns {Promise<ContentType>}
 */
export const getContentType = async (contentTypeId) => {
  const result = await api.get(`/content-management/v1-0/admin/content-types/${contentTypeId}`);

  try {
    await contentTypeSchema.validateAsync(result.data, { allowUnknown: true });
  } catch (error) {
    throw new Error(`API response do not match Content Type Schema : ${error.message}`);
  }

  return result.data;
};
/**
 * Get all content types
 * @returns {Promise<{data: ContentType[]}>}
 */
export const getAllContentTypes = async () => {
  const result = await api.get('/content-management/v1-0/admin/content-types');

  try {
    const schema = Joi.object({
      data: Joi.array().items(contentTypeSchema).required(),
    });
    await schema.validateAsync(result.data, { allowUnknown: true });
  } catch (error) {
    throw new Error(`API response do not match All Content Type Schema : ${error.message}`);
  }

  return result.data;
};
